//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"Angle",0,0],[1,"AngleExp",0,"Expression",0],[0,"CylinderDiameter",0,0],[1,"CylindricalFace",0,"SelectDisplayableObject",0],[0,"ExtendStart",1,0],[0,"HolePreference",1,0],[0,"IsInternalThread",0,0],[0,"MajorDiameter",0,0],[1,"MajorDiameterExp",0,"Expression",0],[0,"MatchThreadSizeToCylinder",1,0],[0,"MinorDiameter",0,0],[1,"MinorDiameterExp",0,"Expression",0],[0,"NumStarts",1,0],[0,"Pitch",0,0],[1,"PitchExp",0,"Expression",0],[1,"PitchMultiple",0,"Expression",0],[0,"RadialEngage",1,0],[0,"ReverseThreadDirection",1,0],[0,"ShaftDiameter",0,0],[1,"ShaftDiameterExp",0,"Expression",0],[0,"ShaftPreference",1,0],[0,"SmartThread",1,1],[1,"StartObject",0,"SelectDisplayableObject",0],[0,"TapDrillDiameter",0,0],[1,"TapDrillDiameterExp",0,"Expression",0],[0,"Tapered",0,0],[0,"TaperedValue",1,0],[0,"ThreadHandedness",1,0],[0,"ThreadInput",1,0],[1,"ThreadLength",0,"Expression",0],[0,"ThreadLimit",1,0],[0,"ThreadMethod",1,0],[0,"ThreadSize",1,0],[0,"ThreadStandard",1,0],[0,"ThreadType",1,0]],[[["numberDecalStickers"],"GetDecalStickers",{R_:{decalStickers:""}},0,0]],[]];
SPLM.Features.ThreadBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ThreadBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ThreadBuilder.Type = Object.freeze({
    "Symbolic" : "Symbolic", "Detailed" : "Detailed"});

SPLM.Features.ThreadBuilder.Input = Object.freeze({
    "ThreadTable" : "ThreadTable", "Manual" : "Manual"});

SPLM.Features.ThreadBuilder.LimitOption = Object.freeze({
    "Value" : "Value", "Full" : "Full", "ShortofFull" : "ShortofFull"});

SPLM.Features.ThreadBuilder.Handedness = Object.freeze({
    "RightHand" : "RightHand", "LeftHand" : "LeftHand"});

SPLM.Features.ThreadBuilder.HoleSizePreference = Object.freeze({
    "TapDrillDiameter" : "TapDrillDiameter", "MajorDiameter" : "MajorDiameter"});

SPLM.Features.ThreadBuilder.ShaftSizePreference = Object.freeze({
    "MajorDiameter" : "MajorDiameter", "ShaftDiameter" : "ShaftDiameter"});

export default SPLM;